const firstTimeModalSuccess = {
  'first-time-modal-success-title': 'Done!',
  'first-time-modal-success-message': 'You have successfully subscribed to our newsletter. Please open your email and complete the verification to start receiving our updates.',
  'first-time-modal-email-domain-not-fund': 'Email service not recognized. Please open your email manually.'
};

export default firstTimeModalSuccess;
